import 'turbolinks-animate'

document.addEventListener('turbolinks:load', () => {
  TurbolinksAnimate.init({animation: 'fadeIn', duration: '200ms'});

  document.querySelectorAll('.block').forEach(block => {
    block.querySelectorAll('a').forEach(anchor => anchor.target = '_blank')
  })
})